import { aggregateGranularities, aggregateTypes } from '@/constants/powerMarkets/ChartAggregateOptions.ts';
import { ICombinedAggregateOptions } from '@/interfaces/powerMarkets/charts/IModuleChartConfig.ts';
import { IChartSeriesAdditionalDetails } from '@/interfaces/powerMarkets/IModule.ts';

function hasProvidedAggregateOptions (
    options: ICombinedAggregateOptions | null | undefined,
): options is ICombinedAggregateOptions {
    return options != null;
}

function getClearedAggregateOptions (): ICombinedAggregateOptions {
    return {
        granularity: null,
        type: null,
    };
}

function getDefaultAggregateOptionsFromAdditionalDetails (
    additionalDetails: Record<string, IChartSeriesAdditionalDetails> | null | undefined,
): ICombinedAggregateOptions | undefined {
    if (!additionalDetails) return undefined;

    const validSeries = Object.values(additionalDetails).find(
        details => details?.defaultGranularity || details?.defaultGranularityType,
    );
    if (!validSeries) return undefined;

    const validGranularityIds = aggregateGranularities.map(granularity => granularity.id);
    const isValidGranularity = !!validSeries.defaultGranularity
        && validGranularityIds.includes(validSeries.defaultGranularity);

    const validGranularityTypeIds = aggregateTypes.map(type => type.id);
    const isValidGranularityType = !!validSeries.defaultGranularityType
        && validGranularityTypeIds.includes(validSeries.defaultGranularityType);

    if (!isValidGranularity && !isValidGranularityType) return undefined;

    return {
        granularity: isValidGranularity ? validSeries.defaultGranularity : null,
        type: isValidGranularityType ? validSeries.defaultGranularityType : null,
    };
}

export {
    getClearedAggregateOptions,
    getDefaultAggregateOptionsFromAdditionalDetails,
    hasProvidedAggregateOptions,
};
